import { InformationDrawerProps } from "../../Unknown/InformationDrawer";
import useTranslations from "./useTranslations";

const useInformationDrawerActionButtons = (params: {
  isEditMode: boolean;
  isButtonsDisabled: boolean;
  handleEditModeChange: (value: boolean) => void;
  handleSubmit: () => void;
  resetForm: () => void;
  canMerge?: boolean;
  onMergeClick?: () => void;
}) => {
  const {
    isEditMode,
    isButtonsDisabled,
    handleEditModeChange,
    handleSubmit,
    resetForm,
    canMerge,
    onMergeClick,
  } = params;

  const { translations } = useTranslations();

  const { btnEdit, btnCancel, btnSave, btnMerge } = translations;

  if (!isEditMode) {
    const viewModeButtons: InformationDrawerProps["actionButtons"] = [];

    if (canMerge && onMergeClick) {
      viewModeButtons.push({
        text: btnMerge,
        props: {
          disabled: isButtonsDisabled,
          variant: "contained",
          onClick: onMergeClick,
        },
      });
    }

    viewModeButtons.push({
      text: btnEdit,
      props: {
        disabled: isButtonsDisabled,
        variant: "outlined",
        onClick: () => handleEditModeChange(true),
      },
    });

    return viewModeButtons;
  }

  const editModeButtons: InformationDrawerProps["actionButtons"] = [
    {
      text: btnCancel,
      props: {
        disabled: isButtonsDisabled,
        variant: "text",
        onClick: () => {
          resetForm();
          handleEditModeChange(false);
        },
      },
    },
    {
      text: btnSave,
      props: {
        disabled: isButtonsDisabled,
        variant: "contained",
        onClick: handleSubmit,
      },
    },
  ];

  return editModeButtons;
};

export default useInformationDrawerActionButtons;
